import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { CreditCardFormSharedComponent } from './credit-card-form.component';

import { ButtonSharedModule } from '../../atoms/button/button.module';
import { CheckBoxSharedModule } from '../../atoms/checkbox/checkbox.module';
import { IconSharedModule } from '../../atoms/icon/icon.module';
import { InputSharedModule } from '../../molecules/input/input.module';
import { InputTooltipSharedModule } from '../../molecules/input-tooltip/input-tooltip.module';
import { CreditCardSharedModule } from '../../molecules/credit-card/credit-card.module';
import { ExpirySharedModule } from '../../molecules/expiry/expiry.module';

@NgModule({
    declarations: [
        CreditCardFormSharedComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgbDropdownModule,

        ButtonSharedModule,
        CheckBoxSharedModule,
        IconSharedModule,
        InputSharedModule,
        InputTooltipSharedModule,
        CreditCardSharedModule,
        ExpirySharedModule
    ],
    exports: [
        CreditCardFormSharedComponent
    ]
})

export class CreditCardFormSharedModule {}
